import {InactiveOrderReminderDealershipSettings} from "./InactiveOrderReminder";

export const parseEmailList = (raw?: string | null): string[] => {
    if (!raw) {
        return [];
    }
    const unique = new Set<string>();
    raw.split(",").forEach((part) => {
        const trimmed = part.trim();
        if (trimmed) {
            unique.add(trimmed);
        }
    });
    return [...unique];
};

export const buildRecipientEmails = (row: InactiveOrderReminderDealershipSettings): string[] => {
    const emails: string[] = [];

    if (row.dealershipEmailSettings?.length) {
        row.dealershipEmailSettings
            .filter((e) => e.sendEnabled && e.email?.trim())
            .forEach((e) => emails.push(e.email.trim()));
    } else if (row.includeDealershipEmail && row.dealershipEmail) {
        parseEmailList(row.dealershipEmail).forEach((email) => emails.push(email));
    }

    (row.users || [])
        .filter((u) => u.sendEnabled && u.email)
        .forEach((u) => {
            parseEmailList(u.email).forEach((email) => emails.push(email));
        });

    return [...new Set(emails)];
};
